import AddMessage from './actions/AddMessage'
import UpdateComponentIndexPos from './actions/UpdateComponentIndexPos'
import UpdateDepthCompIndexPos from './actions/UpdateDepthCompIndexPos'
import AddComponent from './actions/AddComponent'
import DeleteMessage from './actions/DeleteMessage'
import UpdateRow from './actions/UpdateRow'
import CopyComponent from './actions/CopyComponent'
import UpdateComponent from './actions/UpdateComponent'
import UpdateSlidePageToMessage from './actions/UpdateSlidePageToMessage'
import DeleteComponent from './actions/DeleteComponent'
import UpdateMessageIndex from './actions/UpdateMessageIndex'
import DeleteDepthComponent from './actions/DeleteDepthComponent'

/**
 * First parameter of all actions is messages to updating (Except some actions)
 */
// export const MessageActions = {
export default {
  /**
   * Add instance message 
   */
  ADD_MESSAGE: AddMessage,
  /**
   * Replace component index position 
   */
  UPDATE_COMPONENT_INDEX_POS: UpdateComponentIndexPos,
  /**
   * Replace depth component index position 
   */
  UPDATE_DEPTH_COMPONENT_INDEX_POS: UpdateDepthCompIndexPos,
  /**
   * Add component 
   */
  ADD_COMPONENT: AddComponent,
  /**
   * Delete message 
   */
  DELETE_MESSAGE: DeleteMessage,
  /**
   * Update index of message
   */
  UPDATE_MESSAGE_INDEX: UpdateMessageIndex,
  /**
   * Update row
   */
  UPDATE_ROW: UpdateRow,
  /**
   * Copy component
   */
  COPY_COMPONENT: CopyComponent,
  /**
   * Update component property values
   */
  UPDATE_COMPONENT: UpdateComponent,
  /**
   * Update current editing slide page to message
   */
  UPDATE_SLIDE_PAGE_TO_MESSAGE: UpdateSlidePageToMessage,
  /**
   * Update current editing slide page to message
   */
  DELETE_COMPONENT: DeleteComponent,
  /**
   * Update current editing slide page to message
   */
  DELETE_DEPTH_COMPONENT: DeleteDepthComponent,
}

